export default "__VITE_ASSET__6d457193__"